<template>
  <DropdownMenuRoot
    v-if="channelStore.permissions.manageContests"
    v-model:open="isOpen"
  >
    <DropdownMenuTrigger>
      <slot name="trigger"></slot>
    </DropdownMenuTrigger>

    <DropdownMenuPortal>
      <DropdownMenuContent
        class="outline-none shadow bg-brand-bgdivider-20 backdrop-blur-3xl p-2 rounded-xl will-change-[opacity,transform] data-[side=top]:animate-slideDownAndFade data-[side=right]:animate-slideLeftAndFade data-[side=bottom]:animate-slideUpAndFade data-[side=left]:animate-slideRightAndFade min-w-60 z-50 font-sans text-basics-secondary-80 text-sm"
        :side-offset="5"
      >
        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-bgdivider-20 data-[highlighted]:text-basics-secondary-80 rounded-md px-2 py-1 gap-2"
          @click="onNewQuiz"
        >
          {{ $t("channel.contests.creation.quiz") }}
        </DropdownMenuItem>
        <DropdownMenuItem
          class="flex items-center select-none outline-none data-[highlighted]:bg-brand-bgdivider-20 data-[highlighted]:text-basics-secondary-80 rounded-md px-2 py-1 gap-2"
          @click="onNewRaffle"
        >
          {{ $t("channel.contests.creation.raffle") }}
        </DropdownMenuItem>

        <DropdownMenuArrow class="fill-brand-bgdivider-20 backdrop-blur-3xl" />
      </DropdownMenuContent>
    </DropdownMenuPortal>
  </DropdownMenuRoot>
</template>

<script setup lang="ts">
import { RouteNames } from "@/router/app.router";
import { useChannelStore } from "@/stores/channel.store";
import { useRouter } from "vue-router";

import {
  DropdownMenuArrow,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
} from "reka-ui";
import { ref } from "vue";
import { useAwaitAction } from "@/composables/use-await-action";
import {
  CreateDraftQuizDocument,
  CreateDraftRaffleDocument,
} from "@/generated/graphql";
import { useMutation } from "@vue/apollo-composable";
import { useUserStore } from "@/stores/user.store";

const router = useRouter();
const channelStore = useChannelStore();

const isOpen = ref(false);

const { mutate: createDraftRaffle } = useMutation(CreateDraftRaffleDocument);

const userStore = useUserStore();

const { handler: onNewRaffle } = useAwaitAction(async () => {
  // TODO: implement continue last draft raffle

  const raffle = await createDraftRaffle({
    input: {
      channel_id: channelStore.channel!.id,
      created_by_id: userStore.user!.id,
    },
  });

  const result = raffle?.data?.createDraftRaffle;
  if (!result || !("id" in result)) return;
  router.push({
    name: RouteNames.EditRaffle,
    params: {
      raffle: result.id,
      channel: channelStore.channelSlug,
    },
  });
});

const { mutate: createDraftQuiz } = useMutation(CreateDraftQuizDocument);

const { handler: onNewQuiz } = useAwaitAction(async () => {
  // TODO: implement continue last draft quiz

  const quiz = await createDraftQuiz({
    input: {
      channel_id: channelStore.channel!.id,
      created_by_id: userStore.user!.id,
    },
  });
  const result = quiz?.data?.createDraftQuiz;
  if (!result || !("id" in result)) return;
  router.push({
    name: RouteNames.EditQuiz,
    params: {
      quiz: result.id,
      channel: channelStore.channelSlug,
    },
  });
});
</script>
